import React from "react";

// Index each mixed load (group with >1 row) in display order so bands strictly alternate blue/amber.
export const mixIndexOf = (rows) => {
  const cnt = {}; rows.forEach((r) => { if (r.group_id) cnt[r.group_id] = (cnt[r.group_id] || 0) + 1; });
  const idx = {}; let n = 0;
  rows.forEach((r) => { if (r.group_id && cnt[r.group_id] > 1 && !(r.group_id in idx)) idx[r.group_id] = n++; });
  return idx;
};

const band = (mi) => (mi % 2 ? "b" : "a");

export const rowTone = (mixIdx, serial) => (mixIdx !== undefined ? `row-mix-${band(mixIdx)}` : (serial % 2 ? "row-odd" : "row-even"));

export const mixTotalTone = (mixIdx) => `mix-total-${band(mixIdx)}`;

export const MixChip = ({ count, mixIdx }) => (
  <span className={`mix-chip mix-chip-${band(mixIdx)}`} title="Mixed load — multiple deliveries on one truck">MIX · {count}</span>
);

export const OwnerBadge = ({ name }) => {
  const own = (name || "").trim().toLowerCase() === "own";
  return (
    <span className={`owner-badge ${own ? "owner-own" : "owner-market"}`} title={name || ""} data-testid="owner-badge">{name || "-"}</span>
  );
};

// Load Location filter; a mixed load stays whole if any of its lines matches.
export const filterByLoadLocation = (rows, loc, field = "load_location") => {
  if (!loc || loc === "all") return rows;
  const hit = (r) => (r[field] || "").trim() === loc;
  const groups = new Set(rows.filter((r) => r.group_id && hit(r)).map((r) => r.group_id));
  return rows.filter((r) => (r.group_id ? groups.has(r.group_id) : hit(r)));
};
